import React from "react";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

import ReactJson from "react-json-view";
import decodeParams from "../decodeParams"

class JsonTableViewer extends React.Component {
  constructor(props) {
    super(props);
  }

  handleParse = str => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  render() {
    let { value, user, endpoint, additional } = this.props;

    let message = `* Note: This only applies to ${endpoint} `;
    let message2 = `and ${additional}`;
    let finalMessage = message + message2;

    let values = value;
    let userLists = user;
    let AuditVal;
    let AuditArr = [];
    let AuditArr2 = [];
    let AuditArr3 = [];
    let AuditArr4 = [];
    let emptyArr = [];
    let counter = 0;
    let ignoredPath = ["created_at", "updated_at"];

    // if (values) {
    //     AuditVal = JSON.parse(values.audit)
    // }

    for (let n in values) {
      AuditVal = JSON.parse(values[n].audit);

       //console.log("values[n]",values[n])
       //console.log("AuditVal",AuditVal)

      for (let a in AuditVal) {
        AuditVal[a].id = counter;
        AuditVal[a].created_at = values[n].created_at;
        AuditVal[a].created_by = values[n].created_by;
        AuditArr.push(AuditVal[a]);

        counter++;
      }
    }

    for (let b in AuditArr) {
      if (
        AuditArr[b].path[0] == "connection" ||
        AuditArr[b].path[0] == "options" ||
        AuditArr[b].path[0] == "datasource"
      ) {
        if (AuditArr[b].kind == "E") {

          let parseLHS = {}
          let parseRHS = {}
          let lhs = AuditArr[b].lhs
          let rhs = AuditArr[b].rhs

          try {

              rhs = decodeParams(AuditArr[b].rhs)

              parseRHS = JSON.parse(AuditArr[b].rhs);

              lhs = decodeParams(AuditArr[b].lhs)

              parseLHS = JSON.parse(AuditArr[b].lhs);
            
          } catch(e) {

              console.log('decode rhs error: ', e)
          } 

          try {

              parseRHS = JSON.parse(rhs);
            
          } catch(e) {

              //console.log('parse rhs error: ', e)
          }          

          let metaTypesLHS = [];
          let metaTypesRHS = [];
          if (parseLHS && parseLHS.hasOwnProperty("meta")) {
            let metaLHS = parseLHS.meta;

            for (let q in metaLHS) {
              if (metaLHS[q].type == "password") {
                metaTypesLHS.push(q);
              }
            }
            if (parseLHS && metaTypesLHS.length > 0) {
              for (let w in metaTypesLHS) {
                let getFirstWord = metaTypesLHS[w].split(".")[0];
                // delete parseLHS[metaTypesLHS[w]]
                delete parseLHS[getFirstWord];
                AuditArr[b].lhs = JSON.stringify(parseLHS);
              }
            }
          }
          if (parseRHS && parseRHS.hasOwnProperty("meta")) {
            let metaRHS = parseRHS.meta;
            for (let o in metaRHS) {
              if (metaRHS[o].type == "password") {
                metaTypesRHS.push(o);
              }
            }
            if (parseRHS && metaTypesRHS.length > 0) {
              for (let p in metaTypesRHS) {
                let getFirstWord = metaTypesRHS[p].split(".")[0];
                // delete parseRHS[metaTypesRHS[p]]
                delete parseRHS[getFirstWord];
                AuditArr[b].rhs = JSON.stringify(parseRHS);
              }
            }
          }
        } else if (AuditArr[b].kind == "N") {

          let parseLHS = {}
          let parseRHS = {}
          let lhs = AuditArr[b].lhs
          let rhs = AuditArr[b].rhs

          try {

              rhs = decodeParams(AuditArr[b].rhs)

              parseRHS = JSON.parse(AuditArr[b].rhs);

              lhs = decodeParams(AuditArr[b].lhs)

              parseLHS = JSON.parse(AuditArr[b].lhs);
            
          } catch(e) {

              
          }

          let metaTypesRHS = [];
          if (parseRHS && parseRHS.hasOwnProperty("meta")) {
            let metaRHS = parseRHS.meta;
            for (let o in metaRHS) {
              if (metaRHS[o].type == "password") {
                metaTypesRHS.push(o);
              }
            }
            if (parseRHS && metaTypesRHS.length > 0) {
              for (let p in metaTypesRHS) {
                let getFirstWord = metaTypesRHS[p].split(".")[0];
                // delete parseRHS[metaTypesRHS[p]]
                delete parseRHS[getFirstWord];
                AuditArr[b].rhs = JSON.stringify(parseRHS);
              }
            }
          }
        }
      }

      //Change into full letters
      if (AuditArr[b].kind === "E") {
        AuditArr[b].kind = "Edit";
      } else if (AuditArr[b].kind === "N") {
        AuditArr[b].kind = "New";
      }

      if (AuditArr[b] && AuditArr[b].created_at) {
        let actualValue = AuditArr[b].created_at.toString();
        let displayText =
          actualValue && moment(actualValue).format("MM-DD-YYYY HH:mm:ss");
        AuditArr[b].created_at = displayText;
      }

      //Check if user has created by and transoform it into
      if (AuditArr[b].created_by === 0) {
        AuditArr[b].created_by = "";
      } else {
        let getUsername = userLists.find(
          epn => epn.id === AuditArr[b].created_by
        );

        if (getUsername) {
          AuditArr[b].created_by = getUsername.email;
        }
      }

      //Check old/new value field if its created by and get user id
      if (AuditArr[b].path[0] === "created_by") {
        if (AuditArr[b].lhs) {
          let lhsUserName = userLists.find(epn => epn.id === AuditArr[b].lhs);
          if (lhsUserName) {
            AuditArr[b].lhs = lhsUserName.username;
          }
        }
        if (AuditArr[b].rhs) {
          let rhsUserName = userLists.find(epn => epn.id === AuditArr[b].rhs);
          if (rhsUserName) {
            AuditArr[b].rhs = rhsUserName.username;
          }
        }
      } else if (AuditArr[b].path[0] === "updated_by") {
        if (AuditArr[b].lhs) {
          let lhsUserName = userLists.find(epn => epn.id === AuditArr[b].lhs);
          if (lhsUserName) {
            AuditArr[b].lhs = lhsUserName.username;
          }
        }
        if (AuditArr[b].rhs) {
          let rhsUserName = userLists.find(epn => epn.id === AuditArr[b].rhs);
          if (rhsUserName) {
            AuditArr[b].rhs = rhsUserName.username;
          }
        }
      }
    }

    //Remove updated at from audit
    let f = AuditArr.filter(arr => {
      if (arr.path[0] != "updated_at") {
        return arr;
      }
    });

    //Remove created at audit
    let g = f.filter(arr => {
      return arr.path[0] != "created_at";
    });

    //Push filtered Audit to new Array
    g.forEach(function(element) {
      AuditArr2.push(element);
    });

    let finalArr = AuditArr2.length ? AuditArr2 : emptyArr;

    // console.log("finalArr", finalArr);

    const divStyle = {
      height: "calc(100vh - 226px) !important",
      overflow: "auto !important",
      margin: "5px"
    };

    const colStyle = {
      textAlign: "left",
      fontFamily: "var(--theme-font-family)",
      // backgroundColor: "#125EAC",
      color: "#000000",
      fontSize: "0.875rem"
    };

    const rowStyle = {
      wordWrap: "break-word",
      fontSize: "0.75rem"
    };

    const noteStyle = {
      fontSize: "0.75rem",
      fontStyle: "Italic",
      color: "rgb(206, 206, 206)",
      paddingBottom: "1.00rem",
      paddingTop: "0.25rem"
    };

    const columns = [
      {
        dataField: "created_at",
        text: "Date/Time",
        headerStyle: { width: "150px", ...colStyle },
        style: { ...rowStyle },
        sort: true
      },
      {
        dataField: "created_by",
        text: "User",
        headerStyle: { width: "165px", ...colStyle },
        style: { ...rowStyle }
      },
      {
        dataField: "kind",
        text: "Type",
        headerStyle: { width: "55px", ...colStyle },
        style: { ...rowStyle }
      },
      {
        dataField: "path",
        text: "Field",
        headerStyle: { width: "100px", ...colStyle },
        style: { ...rowStyle }
      },
      {
        dataField: "lhs",
        text: "Old Value",
        headerStyle: { ...colStyle },
        style: { ...rowStyle }
      },
      {
        dataField: "rhs",
        text: "New Value",
        headerStyle: { ...colStyle },
        style: { ...rowStyle }
      }
    ];

    const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} Results
      </span>
    );

    const options = {
      sizePerPage: 10,
      paginationSize: 4,
      pageStartIndex: 1,
      alwaysShowAllBtns: true, // Always show next and previous button
      withFirstAndLast: true, // Hide the going to First and Last page button
      hideSizePerPage: true, // Hide the sizePerPage dropdown always
      hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      // firstPageText: 'First',
      prePageText: "Back",
      nextPageText: "Next",
      // lastPageText: 'Last',
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      // firstPageTitle: 'Next page',
      // lastPageTitle: 'Last page',
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        {
          text: "5",
          value: 5
        },
        {
          text: "10",
          value: 10
        },
        {
          text: "All",
          value: AuditVal ? AuditVal.length : 0
        }
      ] // A numeric array is also available. the purpose of above example is custom the text
    };

    return (
      <div className="audit-table" style={divStyle}>
        {this.props.endpoint && (
          <div style={{ ...noteStyle }}>
            {this.props.additional ? finalMessage : message}
          </div>
        )}
        {AuditVal && AuditArr && (
          <BootstrapTable
            keyField="id"
            data={finalArr}
            columns={columns}
            pagination={paginationFactory(options)}
            striped={true}
            bordered={false}
            noDataIndication={() => <div>No audit available</div>}
          />
        )}
      </div>
    );
  }
}

export default JsonTableViewer;



// WEBPACK FOOTER //
// ./src/components/utilities/tabs/jsontable.js